import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        events: 'Events',
        community: 'Community',
        news: 'News',
        testimonials: 'Stories of Impact',
        resources: 'Resource Library',
        appointments: 'Appointments',
        contact: 'Contact',
        donate: 'Donate',
        calendarTitle: 'Community Impact Calendar',
        viewCalendar: 'View Calendar',
        eventSpotlight: 'Event Spotlight',
        submitEvent: 'Submit Event',
        volunteerHub: 'Volunteer Hub',
        findOpportunities: 'Find Opportunities',
        volunteerLeaderboard: 'Volunteer Leaderboard',
        becomeVolunteer: 'Become a Volunteer',
        registerOrg: 'Register Organization',
        corporateTeams: 'Corporate Teams',
        volunteerLogin: 'Volunteer Login',
        orgLogin: 'Organization Login',
        allServices: 'All Services',
        workforce: 'Workforce Development',
        volunteerService: 'Volunteer Network',
        collaboration: 'Community Collaboration',
        health: 'Health & Wellness',
        housing: 'Housing & Stability',
        blog: 'Blog',
        instructors: 'Our Instructors',
        sponsorship: 'Sponsorship',
      },
      hero: {
        tagline: 'Strengthening Communities, Mobilizing Volunteers',
        title: 'Greater Community Impact',
        subtitle: 'Empowering Savannah and Southeast Georgia through workforce development, health resources, housing stability, and community engagement.',
      },
      heroSlides: {
        s1_headline: 'Empowering People. Mobilizing Volunteers. Strengthening Community.',
        s1_highlight: 'Mobilizing Volunteers.',
        s1_sub: 'Greater Community Impact (GCI) is a Savannah-based nonprofit advancing workforce opportunity, volunteer mobilization, and collaborative community development across Savannah, GA and Southeast Georgia.',
        s1_btn1: 'Learn About the Volunteer Network',
        s1_btn2: 'Become a Volunteer',
        s1_btn3: 'Register Organization',
        s2_headline: 'Workforce Development for a Stronger Community',
        s2_sub: "From job fairs to career coaching, we're building pathways to career advancement and economic opportunity for everyone.",
        s2_btn1: 'View Workforce Programs',
        s3_headline: 'Uniting Organizations for Greater Impact',
        s3_sub: 'When we work together, we achieve more. Join our network of partners making a difference.',
        s3_btn1: 'Learn About Collaboration',
        s4_headline: 'Your Community Impact Calendar for Savannah & Southeast Georgia',
        s4_highlight: 'Community Impact Calendar',
        s4_sub: 'Discover community events from local organizations, job fairs, workshops, and volunteer opportunities across the Savannah area, all in one place.',
        s4_btn1: 'View the Calendar',
        s4_btn2: 'Subscribe to Community Impact Calendar Weekly Newsletter',
      },
      home: {
        donateTitle: 'Donate Today',
        donateDesc: 'Support our mission to strengthen communities across Savannah, GA and Southeast Georgia.',
        getInvolved: 'Get Involved',
        getInvolvedDesc: 'Join our volunteer network and make a meaningful difference in lives.',
        programsTitle: 'Our Programs and Services',
        programsDesc: 'Explore workforce development, health initiatives, and community support.',
        learnMore: 'Learn More',
        hubTitle: 'A Hub for',
        hubHighlight: 'Community Impact',
        hubDesc1: 'Greater Community Impact connects individuals and families to opportunities that support workforce development, education, health, housing stability, and long-term success.',
        hubDesc2: 'We believe that by working together, we can build stronger, more resilient communities across Savannah, GA and Southeast Georgia. Our programs are designed to meet people where they are and provide the support they need to thrive.',
        hubWorkforce: 'Workforce Development',
        hubVolunteer: 'Volunteer Network',
        hubHealth: 'Community Health',
        hubHousing: 'Housing Support',
        learnAboutUs: 'Learn More About Us',
        flagshipBadge: 'Flagship Launch Initiative',
        flagshipTitle: 'Workforce Development & Economic Mobility',
        flagshipDesc: 'Our workforce development programs are designed to create pathways to employment and economic stability for individuals across our community.',
        flagshipItem1: 'Quarterly job fairs with 50+ employers',
        flagshipItem2: 'Resume workshops and interview training',
        flagshipItem3: 'GED pathways and educational support',
        flagshipItem4: 'Employer partnerships for direct hiring',
        flagshipItem5: 'Sponsored GCI career coaching access',
        flagshipItem6: 'Career cohorts and mentorship',
        viewWorkforce: 'View Workforce Programs',
        jobsConnected: 'Jobs Connected',
        placementRate: 'Placement Rate',
        mobilizingVolunteers: 'Mobilizing Volunteers',
        acrossRegion: 'Across Savannah, GA and Southeast Georgia',
        volunteerDesc: 'Our volunteer network connects passionate individuals with meaningful opportunities to serve their community. Whether you have an hour or a day, your time and talents can create lasting impact.',
        volItem1Title: 'Online volunteer registration',
        volItem1Desc: 'Quick and easy sign-up process',
        volItem2Title: 'Skill-based matching',
        volItem2Desc: 'Find opportunities that fit your talents',
        volItem3Title: 'Organization request portal',
        volItem3Desc: 'Connect nonprofits with volunteers',
        volItem4Title: 'Volunteer tracking system',
        volItem4Desc: 'Log hours and track your impact',
        volItem5Title: 'Corporate volunteer days',
        volItem5Desc: 'Team-building with purpose',
        joinVolunteer: 'Join the Volunteer Network',
        aligningLeaders: 'Aligning Leaders.',
        increasingImpact: 'Increasing Impact.',
        collabSubtitle: 'Through strategic partnerships and collaborative initiatives, we bring together organizations, businesses, and community leaders to maximize our collective impact.',
        learnCollaboration: 'Learn About Collaboration',
        ourImpact: 'Our',
        impact: 'Impact',
        impactSubtitle: 'Making a measurable difference in our community every day.',
        focusAreas: 'Our Focus',
        areas: 'Areas',
        focusSubtitle: 'Comprehensive programs addressing the full spectrum of community needs.',
        workforceEd: 'Workforce & Education',
        healthWellness: 'Health & Wellness',
        housingStability: 'Housing & Stability',
        volunteerMob: 'Volunteer Mobilization',
        communityCollab: 'Community Collaboration',
        exploreServices: 'Explore All Services',
        storiesOf: 'Stories of',
        storiesSubtitle: 'Real stories from real people whose lives have been changed through Greater Community Impact programs.',
        featuredStory: 'Featured Story',
        viewAllStories: 'View all stories',
        bePartOf: 'Be Part of the',
        ctaSubtitle: "Whether you're seeking career support, want to volunteer your time, or looking to partner with us, there's a place for you at Greater Community Impact.",
        needCareer: 'I Need Career Support',
        wantVolunteer: 'I Want to Volunteer',
        partnerWithUs: 'Partner With Us',
        donateToday: 'Donate Today',
        upcoming: 'Upcoming',
        eventsLabel: 'Events',
        viewAllEvents: 'View All Events',
        learnMoreRSVP: 'Learn More & RSVP',
        collabCommunity: 'Community Collaborative Meeting',
        collabCommunityDesc: 'Open forum for all community organizations',
        collabWorkforce: 'Workforce Development Collaborative',
        collabWorkforceDesc: 'Convenings with employers and workforce agencies',
        collabWorkforceSubtitle: 'Join the Employer Partner Network',
        collabNonprofit: 'Nonprofit Collaborative Meeting',
        collabNonprofitDesc: 'Cross-sector collaboration and resource sharing',
        collabChamber: 'Chamber Collaboration Meeting',
        collabChamberDesc: 'Business community partnership for growth',
        collabLunch: 'Lunch & Learn Collaboration',
        collabLunchDesc: '60-90 min luncheon sessions on impact topics',
        collabHealthNet: 'Health & Wellness Partner Network',
        collabHealthNetDesc: 'Improving community health outcomes together',
        collabHousingNet: 'Housing Partner Network',
        collabHousingNetDesc: 'Coordinating housing assistance and support',
        collabSummit: 'Partnership Summit',
        collabSummitDesc: 'Annual celebration of partners and impact',
      },
      common: {
        submit: 'Submit', cancel: 'Cancel', save: 'Save', delete: 'Delete', edit: 'Edit',
        search: 'Search', loading: 'Loading...', noResults: 'No results found',
        back: 'Back', next: 'Next', previous: 'Previous', viewAll: 'View All',
        learnMore: 'Learn More', getStarted: 'Get Started', signUp: 'Sign Up',
        logIn: 'Log In', logOut: 'Log Out',
      },
      services: {
        health: 'Health & Wellness',
        housing: 'Housing Stability',
        workforce: 'Workforce Development',
      },
      donate: {
        title: 'Support Our Mission',
        subtitle: 'Every dollar directly impacts families.',
        oneTime: 'One-Time', monthly: 'Monthly',
        donateNow: 'Donate Now', thankYou: 'Thank You!',
      },
      footer: {
        copyright: 'Greater Community Impact, Inc. All rights reserved.',
        madeWith: 'Made with',
        forCommunity: 'for our community.',
        quickLinks: 'Quick Links',
        ourPrograms: 'Our Programs',
        support: 'Support',
        legal: 'Legal',
        mission: 'Greater Community Impact (GCI) exists to strengthen communities by mobilizing volunteers, advancing economic opportunity, and connecting individuals and families to resources that support workforce development, education, health, housing stability, and long-term self-sufficiency.',
        home: 'Home',
        aboutUs: 'About Us',
        newsBlog: 'News & Blog',
        testimonials: 'Testimonials',
        resourceLib: 'Resource Library',
        instructors: 'Our Instructors',
        events: 'Events',
        contact: 'Contact',
        donate: 'Donate',
        workforceDev: 'Workforce Development',
        volunteerNet: 'Volunteer Network',
        communityCollab: 'Community Collaboration',
        healthWellness: 'Health & Wellness',
        housingStability: 'Housing & Stability',
        careerSupport: 'Career Support',
        partnerWithUs: 'Partner With Us',
        partnerDirectory: 'Partner Directory',
        sponsorship: 'Sponsorship',
        sponsorPortal: 'Sponsor Portal',
        volunteer: 'Volunteer',
        developerAPI: 'Developer API',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
        admin: 'Admin',
        myAccount: 'My Account',
        myDashboard: 'My Dashboard',
        instructorPortal: 'Instructor Portal',
      },
      about: {
        badge: 'Our Story',
        title: 'About',
        titleHighlight: 'Greater Community Impact',
        subtitle: 'We are a Savannah-based nonprofit dedicated to strengthening communities across Savannah, GA and Southeast Georgia through workforce development, volunteer mobilization, and collaborative community initiatives.',
        ourMission: 'Our Mission',
        missionText: 'Greater Community Impact (GCI) exists to strengthen communities by mobilizing volunteers, advancing economic opportunity, and connecting individuals and families to resources that support workforce development, education, health, housing stability, and long-term self-sufficiency.',
        ourVision: 'Our Vision',
        visionText: 'To become a central hub for community transformation across Savannah, GA and Southeast Georgia - uniting individuals, organizations, and leaders to create sustainable pathways to opportunity, stability, and growth.',
        ourStory: 'Our Story',
        storyP1: 'Greater Community Impact was founded with a simple but powerful belief: that by working together, we can create meaningful change in our community. What started as a small group of dedicated volunteers has grown into a comprehensive network of programs and partnerships serving thousands across Savannah, GA and Southeast Georgia.',
        storyP2: 'Our flagship Workforce Development initiative launched to address the critical need for job readiness resources and employment connections in our region. Today, we continue to expand our reach, adding volunteer mobilization, community collaboration, and support services that address the full spectrum of community needs.',
        storyP3: 'We are committed to being a trusted partner for individuals seeking opportunity, organizations looking to make a difference, and community leaders working toward a stronger, more resilient Savannah, GA and Southeast Georgia.',
        ourValues: 'Our Values',
        valuesSubtitle: 'These core principles guide everything we do at Greater Community Impact.',
        val1Title: 'Mission-Driven',
        val1Desc: 'Every action we take is guided by our commitment to strengthening communities.',
        val2Title: 'Community-Centered',
        val2Desc: 'We put the needs of our community first, designing programs that address real challenges.',
        val3Title: 'Compassionate',
        val3Desc: 'We approach our work with empathy and understanding for those we serve.',
        val4Title: 'Collaborative',
        val4Desc: 'We believe in the power of partnerships to achieve greater impact together.',
        strategicPriorities: 'Strategic Priorities',
        prioritiesSubtitle: 'Our work is focused on three key areas that drive meaningful community change.',
        workforceAdvancement: 'Workforce Advancement',
        workforceAdvDesc: 'Our flagship initiative focuses on creating pathways to employment through job fairs, training programs, and employer partnerships.',
        volunteerMobilization: 'Volunteer Mobilization',
        volunteerMobDesc: 'We connect passionate individuals with meaningful volunteer opportunities that match their skills and interests.',
        communityCollaboration: 'Community Collaboration',
        communityCollabDesc: 'We bring together organizations and leaders to align efforts, reduce duplication, and increase collective impact.',
        ourTeam: 'Our Team',
        teamSubtitle: 'Meet the dedicated people behind Greater Community Impact.',
        team1Name: 'Community Leadership Team',
        team1Role: 'Board of Directors',
        team1Desc: 'Our board brings together diverse expertise from business, nonprofit, and community sectors.',
        team2Name: 'Program Staff and Volunteers',
        team2Role: 'Dedicated Professionals',
        team2Desc: 'Our team works tirelessly to deliver impactful programs and support our community.',
        team3Name: 'Volunteer Network',
        team3Role: 'Heart of Our Mission',
        team3Desc: 'Hundreds of volunteers power our programs and extend our reach throughout the region.',
        ctaTitle: 'Join Us in Making an',
        ctaHighlight: 'Impact',
        ctaSubtitle: "Whether you want to volunteer, partner with us, or support our mission, there's a place for you at Greater Community Impact.",
        becomeVolunteer: 'Become a Volunteer',
        contactUs: 'Contact Us',
        learnMore: 'Learn More',
      },
      servicesPage: {
        badge: 'What We Do',
        title: 'Services &',
        titleHighlight: 'Causes',
        subtitle: 'Explore our comprehensive programs designed to strengthen communities, create opportunities, and support individuals and families across Savannah, GA and Southeast Georgia.',
        quickAccess: 'Quick Access',
        quickAccessSubtitle: 'Jump directly to the program that interests you.',
        ctaTitle: 'Ready to Get',
        ctaHighlight: 'Involved',
        ctaSubtitle: "Whether you need support or want to contribute, we're here to help you make an impact.",
        getCareerSupport: 'Get Career Support',
        becomeVolunteer: 'Become a Volunteer',
        learnMore: 'Learn More',
        view: 'View',
        flagshipBadge: 'Flagship Initiative',
        svc1Title: 'Workforce Development',
        svc1Desc: 'Comprehensive career readiness and employment support programs including job fairs, resume workshops, interview training, and GED pathways.',
        svc1f1: 'Quarterly Job Fairs', svc1f2: 'Resume Workshops', svc1f3: 'Interview Training', svc1f4: 'GED Pathways', svc1f5: 'Employer Partnerships',
        svc2Title: 'Volunteer Network',
        svc2Desc: 'Connect with meaningful volunteer opportunities that match your skills and interests. Join our network of community champions.',
        svc2f1: 'Online Registration', svc2f2: 'Skill-Based Matching', svc2f3: 'Organization Portal', svc2f4: 'Volunteer Tracking', svc2f5: 'Corporate Programs',
        svc3Title: 'Community Collaboration',
        svc3Desc: 'Bringing together organizations and leaders to align efforts, reduce duplication, and increase collective community impact.',
        svc3f1: 'Workforce Roundtable', svc3f2: 'Nonprofit Forum', svc3f3: 'Chamber Partnership', svc3f4: 'Impact Summit',
        svc4Title: 'Health & Wellness',
        svc4Desc: 'Supporting community health through education, resources, and partnerships that promote physical and mental wellbeing.',
        svc4f1: 'Health Workshops', svc4f2: 'Food Drives', svc4f3: 'Fitness Initiatives', svc4f4: 'Mental Health Support',
        svc5Title: 'Housing & Stability',
        svc5Desc: 'Connecting families to housing resources and financial literacy programs that support long-term economic stability.',
        svc5f1: 'Rental Education', svc5f2: 'Homeownership Workshops', svc5f3: 'Shelter Partnerships', svc5f4: 'Financial Literacy',
      },
      contactPage: {
        badge: "We're Here to Help",
        title: 'Contact',
        titleHighlight: 'Us',
        subtitle: "Have questions about our programs, want to partner with us, or need support? We'd love to hear from you.",
        mailingAddress: 'Mailing Address',
        phone: 'Phone',
        email: 'Email',
        hours: 'Hours',
        monFri: 'Mon - Fri: 9AM - 5PM',
        satSun: 'Sat - Sun: Closed',
        sendMessage: 'Send Us a Message',
        formSubtitle: 'Fill out the form below and our team will respond within 1-2 business days.',
        fullName: 'Full Name',
        emailAddress: 'Email Address',
        phoneNumber: 'Phone Number',
        subject: 'Subject',
        selectSubject: 'Select a subject',
        general: 'General Inquiry',
        workforce: 'Workforce Programs',
        volunteer: 'Volunteer Opportunities',
        partnership: 'Partnership Inquiry',
        donation: 'Donation Question',
        media: 'Media/Press',
        other: 'Other',
        message: 'Message',
        messagePlaceholder: 'How can we help you?',
        sending: 'Sending...',
        sendBtn: 'Send Message',
        connectWithUs: 'Connect With Us',
        connectSubtitle: 'Follow us on social media for updates, stories, and community highlights.',
        quickLinks: 'Quick Links',
        workforcePrograms: 'Workforce Programs',
        volunteerRegistration: 'Volunteer Registration',
        partnerWithUs: 'Partner With Us',
        upcomingEvents: 'Upcoming Events',
        mapDesc: '6205 Abercorn Street, STE 206, Savannah, GA 31405. Serving communities throughout Savannah and Southeast Georgia.',
      },
      donatePage: {
        badge: 'Make a Difference',
        title: 'Support Our',
        titleHighlight: 'Mission',
        subtitle: 'Every dollar you contribute directly impacts families in Savannah and Southeast Georgia through our health, housing, and workforce programs.',
        chooseGift: 'Choose Your Gift',
        customAmount: 'Custom amount',
        monthlyDonation: 'Make this a monthly donation',
        yourInfo: 'Your Information',
        fullName: 'Full Name',
        emailRequired: 'Email *',
        messageOptional: 'Message (optional)',
        messagePlaceholder: 'Share why you are giving...',
        processing: 'Processing...',
        donate: 'Donate',
        perMonth: '/month',
        yourImpact: 'Your Impact',
        recentDonors: 'Recent Donors',
        anonymous: 'Anonymous',
        thankYou: 'Thank You!',
        donationReceived: 'Your donation has been received. Your generosity makes a real difference in our community.',
        returnHome: 'Return Home',
      },
      newsletter: {
        stayConnected: 'Stay Connected',
        title: 'Community Impact Calendar',
        titleHighlight: 'Weekly Newsletter',
        desc: 'Your go-to source for community events from local organizations across Savannah and Southeast Georgia. Discover job fairs, workshops, volunteer opportunities, and more, all in one place.',
        exploreCalendar: 'Explore the Calendar',
        subscribe: 'Subscribe to Community Impact Calendar Weekly Newsletter',
        subscribeNow: 'Subscribe Now',
        subscribing: 'Subscribing...',
        modalTitle: 'Subscribe to the Community Impact Calendar Weekly Newsletter',
        modalDesc: 'Get your first edition delivered instantly when you subscribe, then a weekly roundup of community events, job fairs, workshops, and volunteer opportunities every Sunday.',
        firstName: 'First Name *',
        lastName: 'Last Name *',
        emailAddress: 'Email Address *',
        phoneOptional: 'Phone Number (Optional)',
        consent: 'I consent to receive information, news, and updates from Greater Community Impact. My information will not be sold to third parties.',
        viewCalendar: 'View Calendar',
        benefit1: 'Weekly top picks of community events from local organizations',
        benefit2: 'Job fairs, career workshops, and training opportunities',
        benefit3: 'Volunteer opportunities and community service events',
        benefit4: 'Health, wellness, and family-focused programs from area nonprofits',
      },
      workforcePage: {
        badge: 'Flagship Initiative', title: 'Workforce Development &', titleHighlight: 'Economic Mobility',
        subtitle: 'Building pathways to employment and economic stability through comprehensive career readiness programs, job fairs, and employer partnerships.',
        approach: 'Our', approachHighlight: 'Approach',
        approachP1: "Greater Community Impact's Workforce Development program is designed to meet job seekers where they are and provide the support they need to achieve sustainable employment.",
        approachP2: 'Through partnerships with local employers, educational institutions, and community organizations, we create a comprehensive ecosystem of support.',
        jobsConnected: 'Jobs Connected', employerPartners: 'Employer Partners', placementRate: 'Placement Rate',
        programs: 'Our', programsHighlight: 'Programs', programsSubtitle: 'Comprehensive support for every stage of your career journey.',
        prog1: 'Job Fairs & Hiring Events', prog1d: 'Quarterly job fairs connecting job seekers with 50+ employers actively hiring in the region.',
        prog2: 'Career Readiness Programs', prog2d: 'Resume workshops, interview training, and professional development seminars.',
        prog3: 'GED Pathways', prog3d: 'Educational support and resources for those pursuing their GED certification.',
        prog4: 'Workforce Partnerships', prog4d: 'Direct connections with local employers committed to community hiring.',
        prog5: 'Career Acceleration', prog5d: 'Sponsored access to GCI career coaching and workforce development resources.',
        prog6: 'Career Cohorts', prog6d: 'Group-based career development programs with peer support and mentorship.',
        upcomingEvents: 'Upcoming Workforce', eventsHighlight: 'Events', viewEvent: 'View Event',
        seekerToggle: 'I Need Employment Support', employerToggle: 'Employer Partner Network',
        seekerTitle: 'Employment Support Request', employerTitle: 'Employer Partner Network',
        visionTitle: 'Long-Term', visionHighlight: 'Vision',
        visionText: 'We envision a Savannah, GA and Southeast Georgia where every individual has access to meaningful employment opportunities and the support they need to build lasting careers.',
        visionItem1: 'Regional Workforce Hub', visionItem2: 'Employer Network Expansion', visionItem3: 'Youth Employment Programs',
        formSeekerDesc: 'Looking for a job or career support? Fill out this form and our team will connect you with the right resources.',
        formEmployerDesc: 'Join our Employer Partner Network. By completing this form, you will be added to our internal partner network. As a member, you will have access to Workforce Development Collaborative Meetings and qualified candidate referrals from our team.',
        stepContact: 'Contact', stepContactDesc: 'Your details',
        stepGoals: 'Goals', stepGoalsDesc: 'Career needs',
        stepReview: 'Review', stepReviewDesc: 'Confirm & submit',
        companyName: 'Company Name', contactPersonName: 'Contact Person Name',
        interestArea: 'Interest Area', industry: 'Industry',
        selectArea: 'Select an area', selectIndustry: 'Select your industry',
        jobSearch: 'Job Search Assistance', resumeHelp: 'Resume Assistance',
        interviewPrep: 'Interview Preparation', careerCoaching: 'Career Coaching',
        gedPathway: 'GED Pathway', jobFairReg: 'Job Fair Registration', generalInfo: 'General Information',
        optHealthcare: 'Healthcare', optManufacturing: 'Manufacturing', optHospitality: 'Hospitality & Tourism',
        optRetail: 'Retail', optTechnology: 'Technology', optLogistics: 'Logistics & Transportation',
        optConstruction: 'Construction', optEducation: 'Education', optOther: 'Other',
        careerGoalsLabel: 'Tell Us About Your Career Goals', hiringNeedsLabel: 'Tell Us About Your Hiring Needs',
        careerGoalsPh: 'Describe your career goals, skills, or any specific support you need...',
        hiringNeedsPh: 'Describe available positions, company culture, and how you want to partner with GCI...',
        reviewTitle: 'Review Your Information',
        reviewSeekerHint: 'Review your details above. Click the "Request Employment Support" button below to complete.',
        reviewEmployerHint: 'Review your details above. Click the "Join Employer Network" button below to complete.',
        successSeekerTitle: 'Your Request Has Been Submitted!',
        successEmployerTitle: 'Welcome to the Employer Partner Network!',
        successSeekerMsg: 'Thank you for reaching out. Our team will review your information and connect you with workforce opportunities. Look out for communications from our team.',
        successEmployerMsg: 'You have been added to our Employer Partner Network. You will receive qualified candidate referrals and information about upcoming Workforce Development Collaborative Meetings from our team.',
        submitAnother: 'Submit Another Request',
        submitSeekerLabel: 'Request Employment Support', submitEmployerLabel: 'Join Employer Network',
      },
      healthPage: {
        badge: 'Wellness for All', title: 'Health &', titleHighlight: 'Wellness',
        subtitle: 'Supporting community health through education, resources, and partnerships that promote physical and mental wellbeing for all.',
        overviewTitle: 'A Healthier', overviewHighlight: 'Community',
        overviewP1: 'At Greater Community Impact, we recognize that health and wellness are foundational to economic success and community wellbeing.',
        overviewP2: 'Through partnerships with healthcare providers, community organizations, and wellness programs, we work to ensure that everyone has access to the resources they need.',
        initiatives: 'Our Health', initiativesHighlight: 'Initiatives', initiativesSubtitle: 'Comprehensive programs that support physical and mental wellbeing.',
        prog1: 'Health Workshops', prog1d: 'Educational sessions on preventive health, chronic disease management, and wellness practices.',
        prog2: 'Food Drives & Nutrition', prog2d: 'Community food distribution programs and nutrition education to combat food insecurity.',
        prog3: 'Fitness Initiatives', prog3d: 'Free community fitness programs, walking groups, and access to wellness resources.',
        prog4: 'Mental Health Support', prog4d: 'Partnerships with mental health providers to connect community members with counseling and support services.',
        partnersTitle: 'Our Health Partners',
        partnersDesc: 'We collaborate with a network of healthcare and wellness organizations to bring comprehensive services to our community.',
        partner1: 'Local Health Departments', partner2: 'Community Health Centers', partner3: 'Mental Health Providers',
        partner4: 'Food Banks & Pantries', partner5: 'Fitness Organizations', partner6: 'Wellness Programs',
        getInvolved: 'Get', getInvolvedHighlight: 'Involved',
        getInvolvedDesc: "Whether you're looking for health resources, want to volunteer at a food drive, or represent a health organization interested in partnership, we want to hear from you.",
        involve1: 'Access free health screenings and workshops', involve2: 'Volunteer at community food distributions',
        involve3: 'Connect with mental health resources', involve4: 'Join community fitness programs',
        individualToggle: 'I Need Health Resources', partnerToggle: 'Health and Wellness Partner Network',
        formIndividualTitle: 'Health & Wellness Resources', formPartnerTitle: 'Health and Wellness Partner Network',
        formIndividualDesc: 'Connect with our health and wellness resources. Tell us what you need and we will help.',
        formPartnerDesc: 'Join our Health and Wellness Partner Network. By completing this form, you will be added to our internal partner network. As a member, you will have access to Health and Wellness Partner Network Collaborative Meetings and receive communications from our team.',
        stepInfo: 'Your Info', stepInfoDesc: 'Contact details',
        stepNeeds: 'Needs', stepNeedsDesc: 'What you need',
        stepReview: 'Review', stepReviewDesc: 'Confirm & submit',
        contactPersonName: 'Contact Person Name', orgNameLabel: 'Organization Name',
        interestArea: 'Interest Area', partnerType: 'Partner Type',
        selectArea: 'Select an area', selectPartnerType: 'Select partner type',
        optHealthWorkshops: 'Health Workshops', optFoodAssistance: 'Food Assistance',
        optFitnessPrograms: 'Fitness Programs', optMentalHealth: 'Mental Health Resources',
        optScreenings: 'Health Screenings', optGeneralInfo: 'General Information',
        optHealthcareProvider: 'Healthcare Provider', optMentalHealthOrg: 'Mental Health Organization',
        optFoodBank: 'Food Bank / Pantry', optFitnessOrg: 'Fitness Organization',
        optInsurance: 'Insurance Provider', optNonprofit: 'Health-Focused Nonprofit', optOther: 'Other',
        needsLabel: 'Tell Us About Your Needs', orgLabel: 'Tell Us About Your Organization',
        needsPh: 'Tell us about your health and wellness needs...',
        orgPh: 'Describe your organization and how you want to partner with GCI...',
        reviewTitle: 'Review Your Information',
        reviewIndividualHint: 'Review your details above. Click the "Request Health Resources" button below to complete.',
        reviewPartnerHint: 'Review your details above. Click the "Join Partner Network" button below to complete.',
        successIndividualTitle: 'Your Request Has Been Submitted!',
        successPartnerTitle: 'Welcome to the Health and Wellness Partner Network!',
        successIndividualMsg: 'Thank you for reaching out. Our team will review your information and connect you with health and wellness resources. Look out for communications from our team.',
        successPartnerMsg: 'You have been added to our Health and Wellness Partner Network. You will receive information about upcoming Collaborative Meetings and resources from our team.',
        submitAnother: 'Submit Another Request',
        submitIndividualLabel: 'Request Health Resources', submitPartnerLabel: 'Join Partner Network',
      },
      housingPage: {
        badge: 'A Place to Call Home', title: 'Housing &', titleHighlight: 'Economic Stability',
        subtitle: 'Connecting families to housing resources and financial literacy programs that support long-term economic stability and pathways to homeownership.',
        overviewTitle: 'Building Stable', overviewHighlight: 'Foundations',
        overviewP1: 'Stable housing is the foundation upon which families build their futures. Greater Community Impact works to connect individuals and families with the resources they need.',
        overviewP2: 'From emergency assistance to homeownership education, our housing initiatives address the full spectrum of housing needs.',
        familiesAssisted: 'Families Assisted', housingPartners: 'Housing Partners',
        programs: 'Our Housing', programsHighlight: 'Programs', programsSubtitle: 'Comprehensive support for achieving and maintaining housing stability.',
        prog1: 'Rental Education', prog1d: 'Workshops on tenant rights, lease understanding, and building positive rental history.',
        prog2: 'Homeownership Workshops', prog2d: 'Education programs preparing individuals for the journey to homeownership.',
        prog3: 'Shelter Partnerships', prog3d: 'Connections with emergency and transitional housing resources for those in immediate need.',
        prog4: 'Financial Literacy', prog4d: 'Budgeting, credit building, and financial planning programs to support long-term stability.',
        resources: 'Available', resourcesHighlight: 'Resources',
        resourcesSubtitle: 'We connect community members with a range of housing and financial resources through our partner network.',
        res1: 'Emergency Housing Assistance', res1d: 'Immediate support for housing crises',
        res2: 'Rental Assistance Programs', res2d: 'Help with rent and utility payments',
        res3: 'First-Time Homebuyer Programs', res3d: 'Down payment assistance and education',
        res4: 'Credit Counseling', res4d: 'Improve your financial standing',
        res5: 'Foreclosure Prevention', res5d: 'Support for homeowners at risk',
        res6: 'Fair Housing Resources', res6d: 'Know your rights as a tenant',
        assistToggle: 'I Need Housing Assistance', partnerToggle: 'Housing Partner Network',
        formAssistTitle: 'Housing Assistance Request', formPartnerTitle: 'Housing Partner Network',
        formAssistDesc: 'If you or your family needs help with rent, mortgage, utilities, or other housing needs, fill out this form and our team will connect you with support.',
        formPartnerDesc: 'Join our Housing Partner Network. By completing this form, you will be added to our internal partner network. As a member, you will have access to Housing Partner Network Collaborative Meetings and receive communications from our team.',
        stepContact: 'Contact', stepContactDesc: 'Your details',
        stepSituation: 'Situation', stepSituationDesc: 'Housing needs',
        stepReview: 'Review', stepReviewDesc: 'Confirm & submit',
        contactPersonName: 'Contact Person Name', orgNameLabel: 'Organization Name',
        assistType: 'Type of Assistance Needed', partnerType: 'Partner Type',
        selectType: 'Select type', selectPartnerType: 'Select partner type',
        optRental: 'Rental Assistance', optMortgage: 'Mortgage Assistance',
        optUtility: 'Utility Support', optEmergency: 'Emergency Housing',
        optHomeownership: 'Homeownership Programs', optFinancialLit: 'Financial Literacy',
        optCredit: 'Credit Counseling', optGeneralInfo: 'General Information',
        optHousingAuth: 'Housing Authority', optPropMgmt: 'Property Management',
        optFinancialSvc: 'Financial Services', optLegalAid: 'Legal Aid',
        optUtilityProv: 'Utility Provider', optNonprofit: 'Nonprofit Organization', optOther: 'Other',
        housingStatus: 'Current Housing Status', selectStatus: 'Select status',
        statusStable: 'Currently Stable', statusAtRisk: 'At Risk of Losing Housing',
        statusSeeking: 'Actively Seeking Housing', statusHomeless: 'Currently Without Housing',
        statusHomeowner: 'Homeowner (Seeking Assistance)',
        situationLabel: 'Tell Us About Your Situation', orgLabel: 'Tell Us About Your Organization',
        situationPh: 'Please describe your housing needs...', orgPh: 'Describe your organization and partnership interest...',
        reviewTitle: 'Review Your Information',
        assistTypeLabel: 'Assistance Type',
        reviewAssistHint: 'Review your details above. Click the "Request Housing Assistance" button below to complete.',
        reviewPartnerHint: 'Review your details above. Click the "Join Partner Network" button below to complete.',
        successAssistTitle: 'Your Request Has Been Submitted!',
        successPartnerTitle: 'Welcome to the Housing Partner Network!',
        successAssistMsg: 'Thank you for reaching out. Our team will review your information and connect you with housing resources. Look out for communications from our team.',
        successPartnerMsg: 'You have been added to our Housing Partner Network. You will receive information about upcoming Housing Partner Network Collaborative Meetings and resources from our team.',
        submitAnother: 'Submit Another Request',
        submitAssistLabel: 'Request Housing Assistance', submitPartnerLabel: 'Join Partner Network',
      },
      collabPage: {
        badge: 'Working Together', title: 'Community', titleHighlight: 'Collaboration',
        subtitle: 'Greater Community Impact brings together organizations, businesses, and community leaders to align efforts, reduce duplication, and increase collective impact.',
        init1: 'Community Collaborative Meeting', init1d: 'An open forum for every community organization in the area to come together, learn about changes and trends, and find ways to work together for greater impact.',
        init2: 'Workforce Development Collaborative Meeting', init2d: 'Convenings bringing together employers, workforce agencies, and community organizations to discuss career advancement, employment opportunities, and regional workforce needs.',
        init3: 'Nonprofit Collaborative Meeting', init3d: 'Regular gatherings of nonprofit leaders to share resources, reduce service duplication, and coordinate community impact efforts across the region.',
        init4: 'Chamber Collaboration Meeting', init4d: 'Strategic partnership with the Savannah, Pooler, and Black Chambers of Commerce to bridge business community needs.',
        init5: 'Lunch & Learn Collaboration', init5d: 'GCI hosts 60-90 minute luncheon sessions within your organization to discuss community impact topics.',
        init6: 'Health & Wellness Partner Network', init6d: 'Connecting healthcare providers, mental health organizations, food banks, and wellness programs to improve community health outcomes.',
        init7: 'Housing Partner Network', init7d: 'Coordinating housing-focused organizations to address rental assistance, mortgage support, utility aid, and homeownership pathways.',
        init8: 'Partnership Summit', init8d: 'Annual gathering celebrating achievements and planning for greater collaborative impact.',
        learnMore: 'Learn More',
        partnerForm: 'Partner Interest Form', partnerFormSubtitle: 'Interested in collaborating with GCI? Fill out this form to join our partner network.',
      },
      eventsPage: {
        badge: 'Join Us', title: 'Community', titleHighlight: 'Events',
        subtitle: 'Discover upcoming events, job fairs, workshops, and community gatherings across Savannah and Southeast Georgia.',
        allCategories: 'All Categories', filterBy: 'Filter by category',
        noEvents: 'No events found for this category.', loading: 'Loading events...',
        rsvp: 'RSVP', viewDetails: 'View Details', backToEvents: 'Back to Events',
      },
      volunteerPage: {
        badge: 'Make a Difference', title: 'Volunteer', titleHighlight: 'Network',
        subtitle: "When you sign on to volunteer with GCI, you're joining a network - not volunteering at a single organization. We partner with community organizations all across Chatham County and Southeast Georgia to match you with the causes and organizations that fit your interests and skills.",
        becomeVolunteer: 'Become a Volunteer', registerOrg: 'Register Organization',
        whyVolunteer: 'Why Volunteer', whyHighlight: 'With GCI?',
        whySubtitle: 'We make it easy to find meaningful opportunities that match your skills and schedule.',
        feat1: 'Online Registration', feat1d: 'Quick and easy sign-up process',
        feat2: 'Skill-Based Matching', feat2d: 'Find opportunities that fit your talents',
        feat3: 'Organization Portal', feat3d: 'Connect with local nonprofits',
        feat4: 'Volunteer Tracking', feat4d: 'Log hours and track impact',
        feat5: 'Corporate Programs', feat5d: 'Team volunteer opportunities',
        feat6: 'Flexible Scheduling', feat6d: 'Volunteer on your own time',
        stat1: 'Volunteers Mobilized', stat2: 'Hours Contributed', stat3: 'Partner Organizations', stat4: 'Community Events',
        getStarted: 'Get', getStartedHighlight: 'Started',
        tabVolunteer: 'I Want to Volunteer', tabOrganization: 'Register Organization',
        welcomeTitle: 'Welcome to the GCI Volunteer Network',
        welcomeMsg: 'Your account has been created. Log in to your Volunteer Dashboard to explore opportunities and track your impact.',
        goToDashboard: 'Go to Volunteer Dashboard', logIn: 'Log In',
        joinNetwork: 'Join the GCI Volunteer Network',
        joinSubtitle: 'Create your account. Only 4 fields required, takes under 30 seconds.',
        requiredFields: 'required fields',
        firstName: 'First Name *', lastName: 'Last Name *', emailAddress: 'Email Address *', phoneNumber: 'Phone Number *',
        password: 'Password *', confirmPassword: 'Confirm Password *',
        firstNamePh: 'First name', lastNamePh: 'Last name', emailPh: 'you@email.com', phonePh: '(912) 555-1234',
        passwordPh: 'Min. 8 characters', confirmPh: 'Confirm password',
        personalizeProfile: 'Personalize your profile', hide: 'Hide',
        skills: 'Skills', causesYouCare: 'Causes You Care About',
        consentText: 'I consent to joining the Greater Community Impact Volunteer Network and agree to the',
        termsOfService: 'Terms of Service', privacyPolicy: 'Privacy Policy',
        bgCheckNote: 'Please note: aligning with some nonprofit partners may require a background check for certain volunteer opportunities.',
        creating: 'Creating your account...', joinBtn: 'Join the Volunteer Network',
        alreadyAccount: 'Already have an account?', logInHere: 'Log in here',
        orgTitle: 'Register as a Community Organization Partner',
        orgDesc: "Join the GCI Volunteer Network as a community organization partner. Once registered, you'll be able to request volunteers, post opportunities, and connect with our network of dedicated volunteers across Chatham County and Southeast Georgia.",
        orgFeat1: 'Request Volunteers', orgFeat2: 'Post Opportunities', orgFeat3: 'Track Your Impact',
        registerYourOrg: 'Register Your Organization', alreadyPartner: 'Already a Partner? Log In',
        countySearchPh: 'Type to search counties...',
      },
      formWizard: {
        step: 'Step', of: 'of', next: 'Next', previous: 'Previous', submit: 'Submit', back: 'Back',
        personal: 'Personal Information', employment: 'Employment Details', preferences: 'Preferences',
        review: 'Review & Submit', success: 'Success!',
        fullName: 'Full Name', email: 'Email', phone: 'Phone', address: 'Address',
        city: 'City', state: 'State', zip: 'ZIP Code', county: 'County',
        emailAddress: 'Email Address', phoneNumber: 'Phone Number',
        contactPerson: 'Contact Person', notProvided: 'Not provided', message: 'Message',
        name: 'Name', organization: 'Organization', interest: 'Interest',
        currentEmployment: 'Current Employment Status', employer: 'Current/Previous Employer',
        jobTitle: 'Job Title/Field of Interest', experience: 'Years of Experience',
        education: 'Highest Education Level', resume: 'Resume/CV',
        interests: 'Areas of Interest', availability: 'Availability',
        additionalNotes: 'Additional Notes', howDidYouHear: 'How did you hear about us?',
        submitting: 'Submitting...', submitRequest: 'Submit Request',
        thankYouTitle: 'Thank You!', thankYouMsg: 'Your request has been submitted successfully. Our team will review your information and contact you within 2-3 business days.',
        backToHome: 'Back to Home',
        employed: 'Employed', unemployed: 'Unemployed', selfEmployed: 'Self-Employed',
        student: 'Student', retired: 'Retired',
        fullTime: 'Full-Time', partTime: 'Part-Time', weekends: 'Weekends', flexible: 'Flexible',
        orgName: 'Organization Name', orgType: 'Organization Type', orgWebsite: 'Website',
        orgDescription: 'Organization Description', orgMission: 'Mission Statement',
        contactName: 'Contact Name', contactTitle: 'Contact Title', contactEmail: 'Contact Email', contactPhone: 'Contact Phone',
        partnerInterest: 'Partnership Interest', additionalInfo: 'Additional Information',
      },
    },
  },
  es: {
    translation: {
      nav: {
        home: 'Inicio',
        about: 'Acerca de',
        services: 'Servicios',
        events: 'Eventos',
        community: 'Comunidad',
        news: 'Noticias',
        testimonials: 'Historias de Impacto',
        resources: 'Biblioteca de Recursos',
        appointments: 'Citas',
        contact: 'Contacto',
        donate: 'Donar',
        calendarTitle: 'Calendario de Impacto Comunitario',
        viewCalendar: 'Ver Calendario',
        eventSpotlight: 'Eventos Destacados',
        submitEvent: 'Enviar Evento',
        volunteerHub: 'Centro de Voluntarios',
        findOpportunities: 'Buscar Oportunidades',
        volunteerLeaderboard: 'Tabla de Voluntarios',
        becomeVolunteer: 'Ser Voluntario',
        registerOrg: 'Registrar Organizaci\u00f3n',
        corporateTeams: 'Equipos Corporativos',
        volunteerLogin: 'Inicio de Sesi\u00f3n Voluntario',
        orgLogin: 'Inicio de Sesi\u00f3n Organizaci\u00f3n',
        allServices: 'Todos los Servicios',
        workforce: 'Desarrollo Laboral',
        volunteerService: 'Red de Voluntarios',
        collaboration: 'Colaboraci\u00f3n Comunitaria',
        health: 'Salud y Bienestar',
        housing: 'Vivienda y Estabilidad',
        blog: 'Blog',
        instructors: 'Nuestros Instructores',
        sponsorship: 'Patrocinio',
      },
      hero: {
        tagline: 'Fortaleciendo Comunidades, Movilizando Voluntarios',
        title: 'Mayor Impacto Comunitario',
        subtitle: 'Empoderando a Savannah y el sureste de Georgia a trav\u00e9s del desarrollo laboral, recursos de salud, estabilidad de vivienda y participaci\u00f3n comunitaria.',
      },
      heroSlides: {
        s1_headline: 'Empoderando Personas. Movilizando Voluntarios. Fortaleciendo la Comunidad.',
        s1_highlight: 'Movilizando Voluntarios.',
        s1_sub: 'Greater Community Impact (GCI) es una organizaci\u00f3n sin fines de lucro con sede en Savannah que promueve oportunidades laborales, movilizaci\u00f3n de voluntarios y desarrollo comunitario colaborativo en Savannah, GA y el sureste de Georgia.',
        s1_btn1: 'Conozca la Red de Voluntarios',
        s1_btn2: 'Ser Voluntario',
        s1_btn3: 'Registrar Organizaci\u00f3n',
        s2_headline: 'Desarrollo Laboral para una Comunidad M\u00e1s Fuerte',
        s2_sub: 'Desde ferias de empleo hasta coaching profesional, estamos construyendo caminos hacia el avance profesional y oportunidades econ\u00f3micas para todos.',
        s2_btn1: 'Ver Programas Laborales',
        s3_headline: 'Uniendo Organizaciones para un Mayor Impacto',
        s3_sub: 'Cuando trabajamos juntos, logramos m\u00e1s. \u00danase a nuestra red de socios que hacen la diferencia.',
        s3_btn1: 'Conozca la Colaboraci\u00f3n',
        s4_headline: 'Su Calendario de Impacto Comunitario para Savannah y el Sureste de Georgia',
        s4_highlight: 'Calendario de Impacto Comunitario',
        s4_sub: 'Descubra eventos comunitarios de organizaciones locales, ferias de empleo, talleres y oportunidades de voluntariado en el \u00e1rea de Savannah, todo en un solo lugar.',
        s4_btn1: 'Ver el Calendario',
        s4_btn2: 'Suscribirse al Bolet\u00edn Semanal',
      },
      home: {
        donateTitle: 'Done Hoy',
        donateDesc: 'Apoye nuestra misi\u00f3n de fortalecer comunidades en Savannah, GA y el sureste de Georgia.',
        getInvolved: 'Participe',
        getInvolvedDesc: '\u00danase a nuestra red de voluntarios y haga una diferencia significativa en vidas.',
        programsTitle: 'Nuestros Programas y Servicios',
        programsDesc: 'Explore desarrollo laboral, iniciativas de salud y apoyo comunitario.',
        learnMore: 'M\u00e1s Informaci\u00f3n',
        hubTitle: 'Un Centro de',
        hubHighlight: 'Impacto Comunitario',
        hubDesc1: 'Greater Community Impact conecta a individuos y familias con oportunidades que apoyan el desarrollo laboral, educaci\u00f3n, salud, estabilidad de vivienda y \u00e9xito a largo plazo.',
        hubDesc2: 'Creemos que trabajando juntos podemos construir comunidades m\u00e1s fuertes y resilientes en Savannah, GA y el sureste de Georgia. Nuestros programas est\u00e1n dise\u00f1ados para llegar a las personas donde est\u00e1n y brindar el apoyo que necesitan para prosperar.',
        hubWorkforce: 'Desarrollo Laboral',
        hubVolunteer: 'Red de Voluntarios',
        hubHealth: 'Salud Comunitaria',
        hubHousing: 'Apoyo de Vivienda',
        learnAboutUs: 'Conozca M\u00e1s Sobre Nosotros',
        flagshipBadge: 'Iniciativa Principal de Lanzamiento',
        flagshipTitle: 'Desarrollo Laboral y Movilidad Econ\u00f3mica',
        flagshipDesc: 'Nuestros programas de desarrollo laboral est\u00e1n dise\u00f1ados para crear caminos hacia el empleo y la estabilidad econ\u00f3mica para las personas de nuestra comunidad.',
        flagshipItem1: 'Ferias de empleo trimestrales con m\u00e1s de 50 empleadores',
        flagshipItem2: 'Talleres de curr\u00edculum y preparaci\u00f3n para entrevistas',
        flagshipItem3: 'Caminos hacia GED y apoyo educativo',
        flagshipItem4: 'Alianzas con empleadores para contrataci\u00f3n directa',
        flagshipItem5: 'Acceso patrocinado a coaching de carrera GCI',
        flagshipItem6: 'Cohortes de carrera y mentor\u00eda',
        viewWorkforce: 'Ver Programas Laborales',
        jobsConnected: 'Empleos Conectados',
        placementRate: 'Tasa de Colocaci\u00f3n',
        mobilizingVolunteers: 'Movilizando Voluntarios',
        acrossRegion: 'En Savannah, GA y el Sureste de Georgia',
        volunteerDesc: 'Nuestra red de voluntarios conecta a personas apasionadas con oportunidades significativas para servir a su comunidad. Ya sea que tenga una hora o un d\u00eda, su tiempo y talentos pueden crear un impacto duradero.',
        volItem1Title: 'Registro de voluntarios en l\u00ednea',
        volItem1Desc: 'Proceso de inscripci\u00f3n r\u00e1pido y f\u00e1cil',
        volItem2Title: 'Emparejamiento basado en habilidades',
        volItem2Desc: 'Encuentre oportunidades que se ajusten a sus talentos',
        volItem3Title: 'Portal de solicitud de organizaciones',
        volItem3Desc: 'Conecte organizaciones con voluntarios',
        volItem4Title: 'Sistema de seguimiento de voluntarios',
        volItem4Desc: 'Registre horas y rastree su impacto',
        volItem5Title: 'D\u00edas de voluntariado corporativo',
        volItem5Desc: 'Trabajo en equipo con prop\u00f3sito',
        joinVolunteer: '\u00danase a la Red de Voluntarios',
        aligningLeaders: 'Alineando L\u00edderes.',
        increasingImpact: 'Aumentando el Impacto.',
        collabSubtitle: 'A trav\u00e9s de alianzas estrat\u00e9gicas e iniciativas colaborativas, reunimos organizaciones, empresas y l\u00edderes comunitarios para maximizar nuestro impacto colectivo.',
        learnCollaboration: 'Conozca la Colaboraci\u00f3n',
        ourImpact: 'Nuestro',
        impact: 'Impacto',
        impactSubtitle: 'Haciendo una diferencia medible en nuestra comunidad cada d\u00eda.',
        focusAreas: 'Nuestras \u00c1reas de',
        areas: 'Enfoque',
        focusSubtitle: 'Programas integrales que abordan el espectro completo de necesidades comunitarias.',
        workforceEd: 'Fuerza Laboral y Educaci\u00f3n',
        healthWellness: 'Salud y Bienestar',
        housingStability: 'Vivienda y Estabilidad',
        volunteerMob: 'Movilizaci\u00f3n de Voluntarios',
        communityCollab: 'Colaboraci\u00f3n Comunitaria',
        exploreServices: 'Explorar Todos los Servicios',
        storiesOf: 'Historias de',
        storiesSubtitle: 'Historias reales de personas reales cuyas vidas han sido transformadas a trav\u00e9s de los programas de Greater Community Impact.',
        featuredStory: 'Historia Destacada',
        viewAllStories: 'Ver todas las historias',
        bePartOf: 'Sea Parte del',
        ctaSubtitle: 'Ya sea que busque apoyo profesional, quiera donar su tiempo como voluntario o desee asociarse con nosotros, hay un lugar para usted en Greater Community Impact.',
        needCareer: 'Necesito Apoyo Profesional',
        wantVolunteer: 'Quiero Ser Voluntario',
        partnerWithUs: 'As\u00f3ciese Con Nosotros',
        donateToday: 'Done Hoy',
        upcoming: 'Pr\u00f3ximos',
        eventsLabel: 'Eventos',
        viewAllEvents: 'Ver Todos los Eventos',
        learnMoreRSVP: 'M\u00e1s Info y Confirmar',
        collabCommunity: 'Reuni\u00f3n Colaborativa Comunitaria',
        collabCommunityDesc: 'Foro abierto para todas las organizaciones comunitarias',
        collabWorkforce: 'Colaborativo de Desarrollo Laboral',
        collabWorkforceDesc: 'Reuniones con empleadores y agencias laborales',
        collabWorkforceSubtitle: '\u00danase a la Red de Socios Empleadores',
        collabNonprofit: 'Reuni\u00f3n Colaborativa de ONGs',
        collabNonprofitDesc: 'Colaboraci\u00f3n intersectorial y compartir recursos',
        collabChamber: 'Reuni\u00f3n de Colaboraci\u00f3n con C\u00e1mara',
        collabChamberDesc: 'Alianza de la comunidad empresarial para el crecimiento',
        collabLunch: 'Colaboraci\u00f3n Almuerzo y Aprendizaje',
        collabLunchDesc: 'Sesiones de almuerzo de 60-90 min sobre temas de impacto',
        collabHealthNet: 'Red de Socios de Salud y Bienestar',
        collabHealthNetDesc: 'Mejorando los resultados de salud comunitaria juntos',
        collabHousingNet: 'Red de Socios de Vivienda',
        collabHousingNetDesc: 'Coordinando asistencia y apoyo de vivienda',
        collabSummit: 'Cumbre de Alianzas',
        collabSummitDesc: 'Celebraci\u00f3n anual de socios e impacto',
      },
      common: {
        submit: 'Enviar', cancel: 'Cancelar', save: 'Guardar', delete: 'Eliminar', edit: 'Editar',
        search: 'Buscar', loading: 'Cargando...', noResults: 'No se encontraron resultados',
        back: 'Atr\u00e1s', next: 'Siguiente', previous: 'Anterior', viewAll: 'Ver Todo',
        learnMore: 'M\u00e1s Informaci\u00f3n', getStarted: 'Comienza', signUp: 'Reg\u00edstrate',
        logIn: 'Iniciar Sesi\u00f3n', logOut: 'Cerrar Sesi\u00f3n',
      },
      services: {
        health: 'Salud y Bienestar',
        housing: 'Estabilidad de Vivienda',
        workforce: 'Desarrollo Laboral',
      },
      donate: {
        title: 'Apoya Nuestra Misi\u00f3n',
        subtitle: 'Cada d\u00f3lar impacta directamente a familias.',
        oneTime: 'Una Vez', monthly: 'Mensual',
        donateNow: 'Donar Ahora', thankYou: '\u00a1Gracias!',
      },
      footer: {
        copyright: 'Greater Community Impact, Inc. Todos los derechos reservados.',
        madeWith: 'Hecho con',
        forCommunity: 'para nuestra comunidad.',
        quickLinks: 'Enlaces R\u00e1pidos',
        ourPrograms: 'Nuestros Programas',
        support: 'Apoyo',
        legal: 'Legal',
        mission: 'Greater Community Impact (GCI) existe para fortalecer comunidades movilizando voluntarios, avanzando oportunidades econ\u00f3micas y conectando a individuos y familias con recursos que apoyan el desarrollo laboral, educaci\u00f3n, salud, estabilidad de vivienda y autosuficiencia a largo plazo.',
        home: 'Inicio',
        aboutUs: 'Acerca de Nosotros',
        newsBlog: 'Noticias y Blog',
        testimonials: 'Testimonios',
        resourceLib: 'Biblioteca de Recursos',
        instructors: 'Nuestros Instructores',
        events: 'Eventos',
        contact: 'Contacto',
        donate: 'Donar',
        workforceDev: 'Desarrollo Laboral',
        volunteerNet: 'Red de Voluntarios',
        communityCollab: 'Colaboraci\u00f3n Comunitaria',
        healthWellness: 'Salud y Bienestar',
        housingStability: 'Vivienda y Estabilidad',
        careerSupport: 'Apoyo Profesional',
        partnerWithUs: 'As\u00f3ciese Con Nosotros',
        partnerDirectory: 'Directorio de Socios',
        sponsorship: 'Patrocinio',
        sponsorPortal: 'Portal de Patrocinadores',
        volunteer: 'Voluntariado',
        developerAPI: 'API para Desarrolladores',
        privacyPolicy: 'Pol\u00edtica de Privacidad',
        termsOfService: 'T\u00e9rminos de Servicio',
        admin: 'Administraci\u00f3n',
        myAccount: 'Mi Cuenta',
        myDashboard: 'Mi Panel',
        instructorPortal: 'Portal de Instructores',
      },
      about: {
        badge: 'Nuestra Historia',
        title: 'Acerca de',
        titleHighlight: 'Greater Community Impact',
        subtitle: 'Somos una organizaci\u00f3n sin fines de lucro con sede en Savannah dedicada a fortalecer comunidades en Savannah, GA y el sureste de Georgia a trav\u00e9s del desarrollo laboral, movilizaci\u00f3n de voluntarios e iniciativas comunitarias colaborativas.',
        ourMission: 'Nuestra Misi\u00f3n',
        missionText: 'Greater Community Impact (GCI) existe para fortalecer comunidades movilizando voluntarios, avanzando oportunidades econ\u00f3micas y conectando a individuos y familias con recursos que apoyan el desarrollo laboral, educaci\u00f3n, salud, estabilidad de vivienda y autosuficiencia a largo plazo.',
        ourVision: 'Nuestra Visi\u00f3n',
        visionText: 'Convertirnos en un centro de transformaci\u00f3n comunitaria en Savannah, GA y el sureste de Georgia, uniendo individuos, organizaciones y l\u00edderes para crear caminos sostenibles hacia la oportunidad, estabilidad y crecimiento.',
        ourStory: 'Nuestra Historia',
        storyP1: 'Greater Community Impact fue fundada con una creencia simple pero poderosa: que trabajando juntos, podemos crear un cambio significativo en nuestra comunidad. Lo que comenz\u00f3 como un peque\u00f1o grupo de voluntarios dedicados ha crecido hasta convertirse en una red integral de programas y alianzas que sirven a miles en Savannah, GA y el sureste de Georgia.',
        storyP2: 'Nuestra iniciativa principal de Desarrollo Laboral se lanz\u00f3 para abordar la necesidad cr\u00edtica de recursos de preparaci\u00f3n laboral y conexiones de empleo en nuestra regi\u00f3n. Hoy, continuamos expandiendo nuestro alcance, a\u00f1adiendo movilizaci\u00f3n de voluntarios, colaboraci\u00f3n comunitaria y servicios de apoyo que abordan todo el espectro de necesidades comunitarias.',
        storyP3: 'Estamos comprometidos a ser un socio de confianza para individuos que buscan oportunidades, organizaciones que quieren hacer la diferencia y l\u00edderes comunitarios que trabajan hacia un Savannah, GA y sureste de Georgia m\u00e1s fuerte y resiliente.',
        ourValues: 'Nuestros Valores',
        valuesSubtitle: 'Estos principios fundamentales gu\u00edan todo lo que hacemos en Greater Community Impact.',
        val1Title: 'Orientados por la Misi\u00f3n',
        val1Desc: 'Cada acci\u00f3n que tomamos est\u00e1 guiada por nuestro compromiso de fortalecer comunidades.',
        val2Title: 'Centrados en la Comunidad',
        val2Desc: 'Ponemos las necesidades de nuestra comunidad primero, dise\u00f1ando programas que abordan desaf\u00edos reales.',
        val3Title: 'Compasivos',
        val3Desc: 'Abordamos nuestro trabajo con empat\u00eda y comprensi\u00f3n hacia quienes servimos.',
        val4Title: 'Colaborativos',
        val4Desc: 'Creemos en el poder de las alianzas para lograr un mayor impacto juntos.',
        strategicPriorities: 'Prioridades Estrat\u00e9gicas',
        prioritiesSubtitle: 'Nuestro trabajo se enfoca en tres \u00e1reas clave que impulsan un cambio comunitario significativo.',
        workforceAdvancement: 'Avance Laboral',
        workforceAdvDesc: 'Nuestra iniciativa principal se enfoca en crear caminos hacia el empleo a trav\u00e9s de ferias de trabajo, programas de capacitaci\u00f3n y alianzas con empleadores.',
        volunteerMobilization: 'Movilizaci\u00f3n de Voluntarios',
        volunteerMobDesc: 'Conectamos personas apasionadas con oportunidades significativas de voluntariado que se ajustan a sus habilidades e intereses.',
        communityCollaboration: 'Colaboraci\u00f3n Comunitaria',
        communityCollabDesc: 'Reunimos organizaciones y l\u00edderes para alinear esfuerzos, reducir duplicaci\u00f3n y aumentar el impacto colectivo.',
        ourTeam: 'Nuestro Equipo',
        teamSubtitle: 'Conozca a las personas dedicadas detr\u00e1s de Greater Community Impact.',
        team1Name: 'Equipo de Liderazgo Comunitario',
        team1Role: 'Junta Directiva',
        team1Desc: 'Nuestra junta re\u00fane experiencia diversa de los sectores empresarial, sin fines de lucro y comunitario.',
        team2Name: 'Personal de Programas y Voluntarios',
        team2Role: 'Profesionales Dedicados',
        team2Desc: 'Nuestro equipo trabaja incansablemente para entregar programas impactantes y apoyar a nuestra comunidad.',
        team3Name: 'Red de Voluntarios',
        team3Role: 'Coraz\u00f3n de Nuestra Misi\u00f3n',
        team3Desc: 'Cientos de voluntarios impulsan nuestros programas y extienden nuestro alcance en toda la regi\u00f3n.',
        ctaTitle: '\u00danase a Nosotros para Hacer un',
        ctaHighlight: 'Impacto',
        ctaSubtitle: 'Ya sea que quiera ser voluntario, asociarse con nosotros o apoyar nuestra misi\u00f3n, hay un lugar para usted en Greater Community Impact.',
        becomeVolunteer: 'Ser Voluntario',
        contactUs: 'Cont\u00e1ctenos',
        learnMore: 'M\u00e1s Informaci\u00f3n',
      },
      servicesPage: {
        badge: 'Lo Que Hacemos',
        title: 'Servicios y',
        titleHighlight: 'Causas',
        subtitle: 'Explore nuestros programas integrales dise\u00f1ados para fortalecer comunidades, crear oportunidades y apoyar a individuos y familias en Savannah, GA y el sureste de Georgia.',
        quickAccess: 'Acceso R\u00e1pido',
        quickAccessSubtitle: 'Vaya directamente al programa que le interesa.',
        ctaTitle: '\u00bfListo para',
        ctaHighlight: 'Participar',
        ctaSubtitle: 'Ya sea que necesite apoyo o quiera contribuir, estamos aqu\u00ed para ayudarle a hacer un impacto.',
        getCareerSupport: 'Obtener Apoyo Profesional',
        becomeVolunteer: 'Ser Voluntario',
        learnMore: 'M\u00e1s Informaci\u00f3n',
        view: 'Ver',
        flagshipBadge: 'Iniciativa Principal',
        svc1Title: 'Desarrollo Laboral',
        svc1Desc: 'Programas integrales de preparaci\u00f3n profesional y apoyo al empleo que incluyen ferias de trabajo, talleres de curr\u00edculum, preparaci\u00f3n para entrevistas y caminos hacia el GED.',
        svc1f1: 'Ferias de Empleo Trimestrales', svc1f2: 'Talleres de Curr\u00edculum', svc1f3: 'Preparaci\u00f3n para Entrevistas', svc1f4: 'Caminos GED', svc1f5: 'Alianzas con Empleadores',
        svc2Title: 'Red de Voluntarios',
        svc2Desc: 'Con\u00e9ctese con oportunidades significativas de voluntariado que se ajusten a sus habilidades e intereses. \u00danase a nuestra red de campeones comunitarios.',
        svc2f1: 'Registro en L\u00ednea', svc2f2: 'Emparejamiento por Habilidades', svc2f3: 'Portal de Organizaciones', svc2f4: 'Seguimiento de Voluntarios', svc2f5: 'Programas Corporativos',
        svc3Title: 'Colaboraci\u00f3n Comunitaria',
        svc3Desc: 'Reuniendo organizaciones y l\u00edderes para alinear esfuerzos, reducir duplicaci\u00f3n y aumentar el impacto comunitario colectivo.',
        svc3f1: 'Mesa Redonda Laboral', svc3f2: 'Foro de ONGs', svc3f3: 'Alianza con C\u00e1mara', svc3f4: 'Cumbre de Impacto',
        svc4Title: 'Salud y Bienestar',
        svc4Desc: 'Apoyando la salud comunitaria a trav\u00e9s de educaci\u00f3n, recursos y alianzas que promueven el bienestar f\u00edsico y mental.',
        svc4f1: 'Talleres de Salud', svc4f2: 'Campa\u00f1as de Alimentos', svc4f3: 'Iniciativas de Ejercicio', svc4f4: 'Apoyo de Salud Mental',
        svc5Title: 'Vivienda y Estabilidad',
        svc5Desc: 'Conectando familias con recursos de vivienda y programas de educaci\u00f3n financiera que apoyan la estabilidad econ\u00f3mica a largo plazo.',
        svc5f1: 'Educaci\u00f3n sobre Alquiler', svc5f2: 'Talleres de Vivienda Propia', svc5f3: 'Alianzas con Refugios', svc5f4: 'Educaci\u00f3n Financiera',
      },
      contactPage: {
        badge: 'Estamos Aqu\u00ed para Ayudar',
        title: 'Cont\u00e1ctenos',
        titleHighlight: '',
        subtitle: '\u00bfTiene preguntas sobre nuestros programas, quiere asociarse con nosotros o necesita apoyo? Nos encantar\u00eda saber de usted.',
        mailingAddress: 'Direcci\u00f3n Postal',
        phone: 'Tel\u00e9fono',
        email: 'Correo Electr\u00f3nico',
        hours: 'Horario',
        monFri: 'Lun - Vie: 9AM - 5PM',
        satSun: 'S\u00e1b - Dom: Cerrado',
        sendMessage: 'Env\u00edenos un Mensaje',
        formSubtitle: 'Complete el formulario a continuaci\u00f3n y nuestro equipo responder\u00e1 dentro de 1-2 d\u00edas h\u00e1biles.',
        fullName: 'Nombre Completo',
        emailAddress: 'Correo Electr\u00f3nico',
        phoneNumber: 'N\u00famero de Tel\u00e9fono',
        subject: 'Asunto',
        selectSubject: 'Seleccione un asunto',
        general: 'Consulta General',
        workforce: 'Programas Laborales',
        volunteer: 'Oportunidades de Voluntariado',
        partnership: 'Consulta de Asociaci\u00f3n',
        donation: 'Pregunta sobre Donaci\u00f3n',
        media: 'Medios/Prensa',
        other: 'Otro',
        message: 'Mensaje',
        messagePlaceholder: '\u00bfC\u00f3mo podemos ayudarle?',
        sending: 'Enviando...',
        sendBtn: 'Enviar Mensaje',
        connectWithUs: 'Con\u00e9ctese Con Nosotros',
        connectSubtitle: 'S\u00edganos en redes sociales para actualizaciones, historias y noticias de la comunidad.',
        quickLinks: 'Enlaces R\u00e1pidos',
        workforcePrograms: 'Programas Laborales',
        volunteerRegistration: 'Registro de Voluntarios',
        partnerWithUs: 'As\u00f3ciese Con Nosotros',
        upcomingEvents: 'Pr\u00f3ximos Eventos',
        mapDesc: '6205 Abercorn Street, STE 206, Savannah, GA 31405. Sirviendo comunidades en todo Savannah y el sureste de Georgia.',
      },
      donatePage: {
        badge: 'Haga la Diferencia',
        title: 'Apoye Nuestra',
        titleHighlight: 'Misi\u00f3n',
        subtitle: 'Cada d\u00f3lar que contribuye impacta directamente a familias en Savannah y el sureste de Georgia a trav\u00e9s de nuestros programas de salud, vivienda y desarrollo laboral.',
        chooseGift: 'Elija Su Donaci\u00f3n',
        customAmount: 'Monto personalizado',
        monthlyDonation: 'Hacer esta una donaci\u00f3n mensual',
        yourInfo: 'Su Informaci\u00f3n',
        fullName: 'Nombre Completo',
        emailRequired: 'Correo *',
        messageOptional: 'Mensaje (opcional)',
        messagePlaceholder: 'Comparta por qu\u00e9 est\u00e1 donando...',
        processing: 'Procesando...',
        donate: 'Donar',
        perMonth: '/mes',
        yourImpact: 'Su Impacto',
        recentDonors: 'Donantes Recientes',
        anonymous: 'An\u00f3nimo',
        thankYou: '\u00a1Gracias!',
        donationReceived: 'Su donaci\u00f3n ha sido recibida. Su generosidad hace una diferencia real en nuestra comunidad.',
        returnHome: 'Volver al Inicio',
      },
      newsletter: {
        stayConnected: 'Mant\u00e9ngase Conectado',
        title: 'Calendario de Impacto Comunitario de GCI',
        titleHighlight: 'Bolet\u00edn Semanal',
        desc: 'Su fuente principal de eventos comunitarios de organizaciones locales en Savannah y el sureste de Georgia. Descubra ferias de empleo, talleres, oportunidades de voluntariado y m\u00e1s, todo en un solo lugar.',
        exploreCalendar: 'Explorar el Calendario',
        subscribe: 'Suscribirse al Bolet\u00edn Semanal',
        subscribeNow: 'Suscribirse Ahora',
        subscribing: 'Suscribiendo...',
        modalTitle: 'Suscr\u00edbase al Bolet\u00edn Semanal del Calendario de Impacto Comunitario',
        modalDesc: 'Reciba su primera edici\u00f3n al instante al suscribirse, y luego un resumen semanal de eventos comunitarios, ferias de empleo, talleres y oportunidades de voluntariado cada domingo.',
        firstName: 'Nombre *',
        lastName: 'Apellido *',
        emailAddress: 'Correo Electr\u00f3nico *',
        phoneOptional: 'Tel\u00e9fono (Opcional)',
        consent: 'Consiento recibir informaci\u00f3n, noticias y actualizaciones de Greater Community Impact. Mi informaci\u00f3n no ser\u00e1 vendida a terceros.',
        viewCalendar: 'Ver Calendario',
        benefit1: 'Selecciones semanales de eventos comunitarios de organizaciones locales',
        benefit2: 'Ferias de empleo, talleres de carrera y oportunidades de capacitaci\u00f3n',
        benefit3: 'Oportunidades de voluntariado y eventos de servicio comunitario',
        benefit4: 'Programas de salud, bienestar y familia de organizaciones del \u00e1rea',
      },
      workforcePage: {
        badge: 'Iniciativa Principal', title: 'Desarrollo Laboral y', titleHighlight: 'Movilidad Econ\u00f3mica',
        subtitle: 'Construyendo caminos hacia el empleo y la estabilidad econ\u00f3mica a trav\u00e9s de programas integrales de preparaci\u00f3n profesional, ferias de empleo y alianzas con empleadores.',
        approach: 'Nuestro', approachHighlight: 'Enfoque',
        approachP1: 'El programa de Desarrollo Laboral de Greater Community Impact est\u00e1 dise\u00f1ado para llegar a los buscadores de empleo donde est\u00e1n y brindar el apoyo que necesitan.',
        approachP2: 'A trav\u00e9s de alianzas con empleadores locales, instituciones educativas y organizaciones comunitarias, creamos un ecosistema integral de apoyo.',
        jobsConnected: 'Empleos Conectados', employerPartners: 'Socios Empleadores', placementRate: 'Tasa de Colocaci\u00f3n',
        programs: 'Nuestros', programsHighlight: 'Programas', programsSubtitle: 'Apoyo integral para cada etapa de su trayectoria profesional.',
        prog1: 'Ferias de Empleo', prog1d: 'Ferias de empleo trimestrales conectando buscadores con m\u00e1s de 50 empleadores.',
        prog2: 'Programas de Preparaci\u00f3n', prog2d: 'Talleres de curr\u00edculum, preparaci\u00f3n para entrevistas y desarrollo profesional.',
        prog3: 'Caminos GED', prog3d: 'Apoyo educativo y recursos para quienes buscan su certificaci\u00f3n GED.',
        prog4: 'Alianzas Laborales', prog4d: 'Conexiones directas con empleadores locales comprometidos con la contrataci\u00f3n comunitaria.',
        prog5: 'Aceleraci\u00f3n de Carrera', prog5d: 'Acceso patrocinado a coaching de carrera y recursos de desarrollo laboral de GCI.',
        prog6: 'Cohortes de Carrera', prog6d: 'Programas grupales de desarrollo profesional con apoyo entre pares y mentor\u00eda.',
        upcomingEvents: 'Pr\u00f3ximos Eventos', eventsHighlight: 'Laborales', viewEvent: 'Ver Evento',
        seekerToggle: 'Necesito Apoyo Laboral', employerToggle: 'Red de Socios Empleadores',
        seekerTitle: 'Solicitud de Apoyo Laboral', employerTitle: 'Red de Socios Empleadores',
        visionTitle: 'Visi\u00f3n a', visionHighlight: 'Largo Plazo',
        visionText: 'Visualizamos un Savannah y sureste de Georgia donde cada individuo tenga acceso a oportunidades de empleo significativas y el apoyo que necesita.',
        visionItem1: 'Centro Regional Laboral', visionItem2: 'Expansi\u00f3n de Red de Empleadores', visionItem3: 'Programas de Empleo Juvenil',
        formSeekerDesc: '\u00bfBusca empleo o apoyo profesional? Complete este formulario y nuestro equipo lo conectar\u00e1 con los recursos adecuados.',
        formEmployerDesc: '\u00danase a nuestra Red de Socios Empleadores. Al completar este formulario, ser\u00e1 agregado a nuestra red interna de socios. Como miembro, tendr\u00e1 acceso a Reuniones Colaborativas de Desarrollo Laboral y referencias de candidatos calificados de nuestro equipo.',
        stepContact: 'Contacto', stepContactDesc: 'Sus datos',
        stepGoals: 'Metas', stepGoalsDesc: 'Necesidades profesionales',
        stepReview: 'Revisar', stepReviewDesc: 'Confirmar y enviar',
        companyName: 'Nombre de Empresa', contactPersonName: 'Nombre de Persona de Contacto',
        interestArea: '\u00c1rea de Inter\u00e9s', industry: 'Industria',
        selectArea: 'Seleccione un \u00e1rea', selectIndustry: 'Seleccione su industria',
        jobSearch: 'Asistencia en B\u00fasqueda de Empleo', resumeHelp: 'Asistencia con Curr\u00edculum',
        interviewPrep: 'Preparaci\u00f3n para Entrevistas', careerCoaching: 'Coaching de Carrera',
        gedPathway: 'Camino GED', jobFairReg: 'Registro para Feria de Empleo', generalInfo: 'Informaci\u00f3n General',
        optHealthcare: 'Salud', optManufacturing: 'Manufactura', optHospitality: 'Hospitalidad y Turismo',
        optRetail: 'Comercio', optTechnology: 'Tecnolog\u00eda', optLogistics: 'Log\u00edstica y Transporte',
        optConstruction: 'Construcci\u00f3n', optEducation: 'Educaci\u00f3n', optOther: 'Otro',
        careerGoalsLabel: 'Cu\u00e9ntenos Sobre Sus Metas Profesionales', hiringNeedsLabel: 'Cu\u00e9ntenos Sobre Sus Necesidades de Contrataci\u00f3n',
        careerGoalsPh: 'Describa sus metas profesionales, habilidades o cualquier apoyo espec\u00edfico que necesite...',
        hiringNeedsPh: 'Describa posiciones disponibles, cultura de la empresa y c\u00f3mo desea asociarse con GCI...',
        reviewTitle: 'Revise Su Informaci\u00f3n',
        reviewSeekerHint: 'Revise sus datos arriba. Haga clic en el bot\u00f3n "Solicitar Apoyo Laboral" para completar.',
        reviewEmployerHint: 'Revise sus datos arriba. Haga clic en el bot\u00f3n "Unirse a la Red de Empleadores" para completar.',
        successSeekerTitle: '\u00a1Su Solicitud Ha Sido Enviada!',
        successEmployerTitle: '\u00a1Bienvenido a la Red de Socios Empleadores!',
        successSeekerMsg: 'Gracias por contactarnos. Nuestro equipo revisar\u00e1 su informaci\u00f3n y lo conectar\u00e1 con oportunidades laborales. Est\u00e9 atento a las comunicaciones de nuestro equipo.',
        successEmployerMsg: 'Ha sido agregado a nuestra Red de Socios Empleadores. Recibir\u00e1 referencias de candidatos calificados e informaci\u00f3n sobre pr\u00f3ximas Reuniones Colaborativas de Desarrollo Laboral de nuestro equipo.',
        submitAnother: 'Enviar Otra Solicitud',
        submitSeekerLabel: 'Solicitar Apoyo Laboral', submitEmployerLabel: 'Unirse a Red de Empleadores',
      },
      healthPage: {
        badge: 'Bienestar para Todos', title: 'Salud y', titleHighlight: 'Bienestar',
        subtitle: 'Apoyando la salud comunitaria a trav\u00e9s de educaci\u00f3n, recursos y alianzas que promueven el bienestar f\u00edsico y mental para todos.',
        overviewTitle: 'Una Comunidad', overviewHighlight: 'M\u00e1s Saludable',
        overviewP1: 'En Greater Community Impact, reconocemos que la salud y el bienestar son fundamentales para el \u00e9xito econ\u00f3mico y el bienestar comunitario.',
        overviewP2: 'A trav\u00e9s de alianzas con proveedores de salud, organizaciones comunitarias y programas de bienestar, trabajamos para asegurar que todos tengan acceso a los recursos.',
        initiatives: 'Nuestras Iniciativas de', initiativesHighlight: 'Salud', initiativesSubtitle: 'Programas integrales que apoyan el bienestar f\u00edsico y mental.',
        prog1: 'Talleres de Salud', prog1d: 'Sesiones educativas sobre salud preventiva, manejo de enfermedades cr\u00f3nicas y pr\u00e1cticas de bienestar.',
        prog2: 'Campa\u00f1as de Alimentos y Nutrici\u00f3n', prog2d: 'Programas comunitarios de distribuci\u00f3n de alimentos y educaci\u00f3n nutricional.',
        prog3: 'Iniciativas de Ejercicio', prog3d: 'Programas gratuitos de ejercicio comunitario, grupos de caminata y acceso a recursos de bienestar.',
        prog4: 'Apoyo de Salud Mental', prog4d: 'Alianzas con proveedores de salud mental para conectar a miembros de la comunidad con servicios de asesoramiento.',
        partnersTitle: 'Nuestros Socios de Salud',
        partnersDesc: 'Colaboramos con una red de organizaciones de salud y bienestar para brindar servicios integrales a nuestra comunidad.',
        partner1: 'Departamentos de Salud Locales', partner2: 'Centros de Salud Comunitarios', partner3: 'Proveedores de Salud Mental',
        partner4: 'Bancos de Alimentos', partner5: 'Organizaciones de Ejercicio', partner6: 'Programas de Bienestar',
        getInvolved: 'Part\u00edcipe', getInvolvedHighlight: '',
        getInvolvedDesc: 'Ya sea que busque recursos de salud, quiera ser voluntario en una campa\u00f1a de alimentos o represente a una organizaci\u00f3n de salud interesada en asociarse, queremos saber de usted.',
        involve1: 'Acceda a ex\u00e1menes de salud y talleres gratuitos', involve2: 'Sea voluntario en distribuciones comunitarias de alimentos',
        involve3: 'Con\u00e9ctese con recursos de salud mental', involve4: '\u00danase a programas comunitarios de ejercicio',
        individualToggle: 'Necesito Recursos de Salud', partnerToggle: 'Red de Socios de Salud y Bienestar',
        formIndividualTitle: 'Recursos de Salud y Bienestar', formPartnerTitle: 'Red de Socios de Salud y Bienestar',
        formIndividualDesc: 'Con\u00e9ctese con nuestros recursos de salud y bienestar. D\u00edganos lo que necesita y le ayudaremos.',
        formPartnerDesc: '\u00danase a nuestra Red de Socios de Salud y Bienestar. Al completar este formulario, ser\u00e1 agregado a nuestra red interna. Como miembro, tendr\u00e1 acceso a Reuniones Colaborativas y recibir\u00e1 comunicaciones de nuestro equipo.',
        stepInfo: 'Su Info', stepInfoDesc: 'Datos de contacto',
        stepNeeds: 'Necesidades', stepNeedsDesc: 'Lo que necesita',
        stepReview: 'Revisar', stepReviewDesc: 'Confirmar y enviar',
        contactPersonName: 'Nombre de Persona de Contacto', orgNameLabel: 'Nombre de Organizaci\u00f3n',
        interestArea: '\u00c1rea de Inter\u00e9s', partnerType: 'Tipo de Socio',
        selectArea: 'Seleccione un \u00e1rea', selectPartnerType: 'Seleccione tipo de socio',
        optHealthWorkshops: 'Talleres de Salud', optFoodAssistance: 'Asistencia Alimentaria',
        optFitnessPrograms: 'Programas de Ejercicio', optMentalHealth: 'Recursos de Salud Mental',
        optScreenings: 'Ex\u00e1menes de Salud', optGeneralInfo: 'Informaci\u00f3n General',
        optHealthcareProvider: 'Proveedor de Salud', optMentalHealthOrg: 'Organizaci\u00f3n de Salud Mental',
        optFoodBank: 'Banco de Alimentos', optFitnessOrg: 'Organizaci\u00f3n de Ejercicio',
        optInsurance: 'Proveedor de Seguros', optNonprofit: 'ONG de Salud', optOther: 'Otro',
        needsLabel: 'Cu\u00e9ntenos Sobre Sus Necesidades', orgLabel: 'Cu\u00e9ntenos Sobre Su Organizaci\u00f3n',
        needsPh: 'Cu\u00e9ntenos sobre sus necesidades de salud y bienestar...',
        orgPh: 'Describa su organizaci\u00f3n y c\u00f3mo desea asociarse con GCI...',
        reviewTitle: 'Revise Su Informaci\u00f3n',
        reviewIndividualHint: 'Revise sus datos arriba. Haga clic en el bot\u00f3n "Solicitar Recursos de Salud" para completar.',
        reviewPartnerHint: 'Revise sus datos arriba. Haga clic en el bot\u00f3n "Unirse a la Red de Socios" para completar.',
        successIndividualTitle: '\u00a1Su Solicitud Ha Sido Enviada!',
        successPartnerTitle: '\u00a1Bienvenido a la Red de Socios de Salud y Bienestar!',
        successIndividualMsg: 'Gracias por contactarnos. Nuestro equipo revisar\u00e1 su informaci\u00f3n y lo conectar\u00e1 con recursos de salud y bienestar. Est\u00e9 atento a las comunicaciones de nuestro equipo.',
        successPartnerMsg: 'Ha sido agregado a nuestra Red de Socios de Salud y Bienestar. Recibir\u00e1 informaci\u00f3n sobre pr\u00f3ximas Reuniones Colaborativas y recursos de nuestro equipo.',
        submitAnother: 'Enviar Otra Solicitud',
        submitIndividualLabel: 'Solicitar Recursos de Salud', submitPartnerLabel: 'Unirse a Red de Socios',
      },
      housingPage: {
        badge: 'Un Lugar para Llamar Hogar', title: 'Vivienda y', titleHighlight: 'Estabilidad Econ\u00f3mica',
        subtitle: 'Conectando familias con recursos de vivienda y programas de educaci\u00f3n financiera que apoyan la estabilidad econ\u00f3mica a largo plazo.',
        overviewTitle: 'Construyendo Bases', overviewHighlight: 'Estables',
        overviewP1: 'La vivienda estable es la base sobre la cual las familias construyen su futuro. Greater Community Impact trabaja para conectar a individuos y familias con los recursos que necesitan.',
        overviewP2: 'Desde asistencia de emergencia hasta educaci\u00f3n sobre vivienda propia, nuestras iniciativas abordan todo el espectro de necesidades de vivienda.',
        familiesAssisted: 'Familias Asistidas', housingPartners: 'Socios de Vivienda',
        programs: 'Nuestros Programas de', programsHighlight: 'Vivienda', programsSubtitle: 'Apoyo integral para lograr y mantener la estabilidad de vivienda.',
        prog1: 'Educaci\u00f3n sobre Alquiler', prog1d: 'Talleres sobre derechos del inquilino, comprensi\u00f3n de contratos y construcci\u00f3n de historial de alquiler positivo.',
        prog2: 'Talleres de Vivienda Propia', prog2d: 'Programas educativos preparando a individuos para el camino hacia la vivienda propia.',
        prog3: 'Alianzas con Refugios', prog3d: 'Conexiones con recursos de vivienda de emergencia y transicional para quienes tienen necesidad inmediata.',
        prog4: 'Educaci\u00f3n Financiera', prog4d: 'Programas de presupuesto, construcci\u00f3n de cr\u00e9dito y planificaci\u00f3n financiera para apoyar la estabilidad a largo plazo.',
        resources: 'Recursos', resourcesHighlight: 'Disponibles',
        resourcesSubtitle: 'Conectamos a miembros de la comunidad con una gama de recursos de vivienda y financieros a trav\u00e9s de nuestra red de socios.',
        res1: 'Asistencia de Vivienda de Emergencia', res1d: 'Apoyo inmediato para crisis de vivienda',
        res2: 'Programas de Asistencia de Alquiler', res2d: 'Ayuda con pagos de alquiler y servicios',
        res3: 'Programas para Compradores Primerizos', res3d: 'Asistencia para enganche y educaci\u00f3n',
        res4: 'Asesor\u00eda de Cr\u00e9dito', res4d: 'Mejore su situaci\u00f3n financiera',
        res5: 'Prevenci\u00f3n de Ejecuci\u00f3n Hipotecaria', res5d: 'Apoyo para propietarios en riesgo',
        res6: 'Recursos de Vivienda Justa', res6d: 'Conozca sus derechos como inquilino',
        assistToggle: 'Necesito Asistencia de Vivienda', partnerToggle: 'Red de Socios de Vivienda',
        formAssistTitle: 'Solicitud de Asistencia de Vivienda', formPartnerTitle: 'Red de Socios de Vivienda',
        formAssistDesc: 'Si usted o su familia necesita ayuda con alquiler, hipoteca, servicios p\u00fablicos u otras necesidades de vivienda, complete este formulario y nuestro equipo lo conectar\u00e1 con apoyo.',
        formPartnerDesc: '\u00danase a nuestra Red de Socios de Vivienda. Al completar este formulario, ser\u00e1 agregado a nuestra red interna. Como miembro, tendr\u00e1 acceso a Reuniones Colaborativas de la Red de Socios de Vivienda y recibir\u00e1 comunicaciones de nuestro equipo.',
        stepContact: 'Contacto', stepContactDesc: 'Sus datos',
        stepSituation: 'Situaci\u00f3n', stepSituationDesc: 'Necesidades de vivienda',
        stepReview: 'Revisar', stepReviewDesc: 'Confirmar y enviar',
        contactPersonName: 'Nombre de Persona de Contacto', orgNameLabel: 'Nombre de Organizaci\u00f3n',
        assistType: 'Tipo de Asistencia Necesaria', partnerType: 'Tipo de Socio',
        selectType: 'Seleccione tipo', selectPartnerType: 'Seleccione tipo de socio',
        optRental: 'Asistencia de Alquiler', optMortgage: 'Asistencia Hipotecaria',
        optUtility: 'Apoyo de Servicios P\u00fablicos', optEmergency: 'Vivienda de Emergencia',
        optHomeownership: 'Programas de Vivienda Propia', optFinancialLit: 'Educaci\u00f3n Financiera',
        optCredit: 'Asesor\u00eda de Cr\u00e9dito', optGeneralInfo: 'Informaci\u00f3n General',
        optHousingAuth: 'Autoridad de Vivienda', optPropMgmt: 'Administraci\u00f3n de Propiedades',
        optFinancialSvc: 'Servicios Financieros', optLegalAid: 'Asistencia Legal',
        optUtilityProv: 'Proveedor de Servicios P\u00fablicos', optNonprofit: 'Organizaci\u00f3n Sin Fines de Lucro', optOther: 'Otro',
        housingStatus: 'Estado Actual de Vivienda', selectStatus: 'Seleccione estado',
        statusStable: 'Actualmente Estable', statusAtRisk: 'En Riesgo de Perder Vivienda',
        statusSeeking: 'Buscando Vivienda Activamente', statusHomeless: 'Actualmente Sin Vivienda',
        statusHomeowner: 'Propietario (Buscando Asistencia)',
        situationLabel: 'Cu\u00e9ntenos Sobre Su Situaci\u00f3n', orgLabel: 'Cu\u00e9ntenos Sobre Su Organizaci\u00f3n',
        situationPh: 'Por favor describa sus necesidades de vivienda...', orgPh: 'Describa su organizaci\u00f3n e inter\u00e9s de asociaci\u00f3n...',
        reviewTitle: 'Revise Su Informaci\u00f3n',
        assistTypeLabel: 'Tipo de Asistencia',
        reviewAssistHint: 'Revise sus datos arriba. Haga clic en el bot\u00f3n "Solicitar Asistencia de Vivienda" para completar.',
        reviewPartnerHint: 'Revise sus datos arriba. Haga clic en el bot\u00f3n "Unirse a la Red de Socios" para completar.',
        successAssistTitle: '\u00a1Su Solicitud Ha Sido Enviada!',
        successPartnerTitle: '\u00a1Bienvenido a la Red de Socios de Vivienda!',
        successAssistMsg: 'Gracias por contactarnos. Nuestro equipo revisar\u00e1 su informaci\u00f3n y lo conectar\u00e1 con recursos de vivienda. Est\u00e9 atento a las comunicaciones de nuestro equipo.',
        successPartnerMsg: 'Ha sido agregado a nuestra Red de Socios de Vivienda. Recibir\u00e1 informaci\u00f3n sobre pr\u00f3ximas Reuniones Colaborativas de la Red de Socios de Vivienda y recursos de nuestro equipo.',
        submitAnother: 'Enviar Otra Solicitud',
        submitAssistLabel: 'Solicitar Asistencia de Vivienda', submitPartnerLabel: 'Unirse a Red de Socios',
      },
      collabPage: {
        badge: 'Trabajando Juntos', title: 'Colaboraci\u00f3n', titleHighlight: 'Comunitaria',
        subtitle: 'Greater Community Impact re\u00fane organizaciones, empresas y l\u00edderes comunitarios para alinear esfuerzos, reducir duplicaci\u00f3n y aumentar el impacto colectivo.',
        init1: 'Reuni\u00f3n Colaborativa Comunitaria', init1d: 'Un foro abierto para que cada organizaci\u00f3n comunitaria del \u00e1rea se re\u00fana, aprenda sobre cambios y tendencias, y encuentre formas de trabajar juntos.',
        init2: 'Colaborativo de Desarrollo Laboral', init2d: 'Reuniones que re\u00fanen empleadores, agencias laborales y organizaciones comunitarias para discutir avance profesional y necesidades laborales regionales.',
        init3: 'Reuni\u00f3n Colaborativa de ONGs', init3d: 'Reuniones regulares de l\u00edderes de ONGs para compartir recursos, reducir duplicaci\u00f3n de servicios y coordinar esfuerzos de impacto comunitario.',
        init4: 'Reuni\u00f3n de Colaboraci\u00f3n con C\u00e1mara', init4d: 'Alianza estrat\u00e9gica con las C\u00e1maras de Comercio de Savannah, Pooler y Black para conectar necesidades empresariales con desarrollo laboral.',
        init5: 'Colaboraci\u00f3n Almuerzo y Aprendizaje', init5d: 'GCI organiza sesiones de almuerzo de 60-90 minutos dentro de su organizaci\u00f3n para discutir temas de impacto comunitario.',
        init6: 'Red de Socios de Salud y Bienestar', init6d: 'Conectando proveedores de salud, organizaciones de salud mental, bancos de alimentos y programas de bienestar para mejorar resultados de salud comunitaria.',
        init7: 'Red de Socios de Vivienda', init7d: 'Coordinando organizaciones enfocadas en vivienda para abordar asistencia de alquiler, apoyo hipotecario y caminos hacia la vivienda propia.',
        init8: 'Cumbre de Alianzas', init8d: 'Reuni\u00f3n anual celebrando logros y planificando para un mayor impacto colaborativo.',
        learnMore: 'M\u00e1s Informaci\u00f3n',
        partnerForm: 'Formulario de Inter\u00e9s de Socio', partnerFormSubtitle: '\u00bfInteresado en colaborar con GCI? Complete este formulario para unirse a nuestra red de socios.',
      },
      eventsPage: {
        badge: '\u00danase', title: 'Eventos', titleHighlight: 'Comunitarios',
        subtitle: 'Descubra pr\u00f3ximos eventos, ferias de empleo, talleres y reuniones comunitarias en Savannah y el sureste de Georgia.',
        allCategories: 'Todas las Categor\u00edas', filterBy: 'Filtrar por categor\u00eda',
        noEvents: 'No se encontraron eventos para esta categor\u00eda.', loading: 'Cargando eventos...',
        rsvp: 'Confirmar', viewDetails: 'Ver Detalles', backToEvents: 'Volver a Eventos',
      },
      volunteerPage: {
        badge: 'Haga la Diferencia', title: 'Red de', titleHighlight: 'Voluntarios',
        subtitle: 'Cuando se inscribe como voluntario con GCI, se une a una red, no como voluntario de una sola organizaci\u00f3n. Nos asociamos con organizaciones comunitarias en todo el Condado de Chatham y el sureste de Georgia para conectarlo con las causas y organizaciones que se ajustan a sus intereses y habilidades.',
        becomeVolunteer: 'Ser Voluntario', registerOrg: 'Registrar Organizaci\u00f3n',
        whyVolunteer: 'Por Qu\u00e9 Ser Voluntario', whyHighlight: 'Con GCI?',
        whySubtitle: 'Facilitamos encontrar oportunidades significativas que se ajusten a sus habilidades y horario.',
        feat1: 'Registro en L\u00ednea', feat1d: 'Proceso de inscripci\u00f3n r\u00e1pido y f\u00e1cil',
        feat2: 'Emparejamiento por Habilidades', feat2d: 'Encuentre oportunidades que se ajusten a sus talentos',
        feat3: 'Portal de Organizaciones', feat3d: 'Con\u00e9ctese con ONGs locales',
        feat4: 'Seguimiento de Voluntarios', feat4d: 'Registre horas y rastree su impacto',
        feat5: 'Programas Corporativos', feat5d: 'Oportunidades de voluntariado en equipo',
        feat6: 'Horarios Flexibles', feat6d: 'Sea voluntario en su propio tiempo',
        stat1: 'Voluntarios Movilizados', stat2: 'Horas Contribuidas', stat3: 'Organizaciones Socias', stat4: 'Eventos Comunitarios',
        getStarted: 'Comience', getStartedHighlight: 'Ahora',
        tabVolunteer: 'Quiero Ser Voluntario', tabOrganization: 'Registrar Organizaci\u00f3n',
        welcomeTitle: 'Bienvenido a la Red de Voluntarios de GCI',
        welcomeMsg: 'Su cuenta ha sido creada. Inicie sesi\u00f3n en su Panel de Voluntario para explorar oportunidades y rastrear su impacto.',
        goToDashboard: 'Ir al Panel de Voluntario', logIn: 'Iniciar Sesi\u00f3n',
        joinNetwork: '\u00danase a la Red de Voluntarios de GCI',
        joinSubtitle: 'Cree su cuenta. Solo 4 campos requeridos, toma menos de 30 segundos.',
        requiredFields: 'campos requeridos',
        firstName: 'Nombre *', lastName: 'Apellido *', emailAddress: 'Correo Electr\u00f3nico *', phoneNumber: 'Tel\u00e9fono *',
        password: 'Contrase\u00f1a *', confirmPassword: 'Confirmar Contrase\u00f1a *',
        firstNamePh: 'Nombre', lastNamePh: 'Apellido', emailPh: 'correo@email.com', phonePh: '(912) 555-1234',
        passwordPh: 'M\u00edn. 8 caracteres', confirmPh: 'Confirmar contrase\u00f1a',
        personalizeProfile: 'Personalice su perfil', hide: 'Ocultar',
        skills: 'Habilidades', causesYouCare: 'Causas que le Importan',
        consentText: 'Consiento unirme a la Red de Voluntarios de Greater Community Impact y acepto los',
        termsOfService: 'T\u00e9rminos de Servicio', privacyPolicy: 'Pol\u00edtica de Privacidad',
        bgCheckNote: 'Nota: alinearse con algunos socios sin fines de lucro puede requerir una verificaci\u00f3n de antecedentes para ciertas oportunidades de voluntariado.',
        creating: 'Creando su cuenta...', joinBtn: '\u00danase a la Red de Voluntarios',
        alreadyAccount: '\u00bfYa tiene una cuenta?', logInHere: 'Inicie sesi\u00f3n aqu\u00ed',
        orgTitle: 'Reg\u00edstrese como Organizaci\u00f3n Comunitaria',
        orgDesc: '\u00danase a la Red de Voluntarios de GCI como organizaci\u00f3n comunitaria. Una vez registrada, podr\u00e1 solicitar voluntarios, publicar oportunidades y conectarse con nuestra red de voluntarios dedicados en el Condado de Chatham y el sureste de Georgia.',
        orgFeat1: 'Solicitar Voluntarios', orgFeat2: 'Publicar Oportunidades', orgFeat3: 'Rastrear Su Impacto',
        registerYourOrg: 'Registre Su Organizaci\u00f3n', alreadyPartner: '\u00bfYa es socio? Inicie Sesi\u00f3n',
        countySearchPh: 'Escriba para buscar condados...',
      },
      formWizard: {
        step: 'Paso', of: 'de', next: 'Siguiente', previous: 'Anterior', submit: 'Enviar', back: 'Atr\u00e1s',
        personal: 'Informaci\u00f3n Personal', employment: 'Detalles de Empleo', preferences: 'Preferencias',
        review: 'Revisar y Enviar', success: '\u00a1\u00c9xito!',
        fullName: 'Nombre Completo', email: 'Correo', phone: 'Tel\u00e9fono', address: 'Direcci\u00f3n',
        city: 'Ciudad', state: 'Estado', zip: 'C\u00f3digo Postal', county: 'Condado',
        emailAddress: 'Correo Electr\u00f3nico', phoneNumber: 'N\u00famero de Tel\u00e9fono',
        contactPerson: 'Persona de Contacto', notProvided: 'No proporcionado', message: 'Mensaje',
        name: 'Nombre', organization: 'Organizaci\u00f3n', interest: 'Inter\u00e9s',
        currentEmployment: 'Estado de Empleo Actual', employer: 'Empleador Actual/Anterior',
        jobTitle: 'Puesto/Campo de Inter\u00e9s', experience: 'A\u00f1os de Experiencia',
        education: 'Nivel Educativo M\u00e1s Alto', resume: 'Curr\u00edculum/CV',
        interests: '\u00c1reas de Inter\u00e9s', availability: 'Disponibilidad',
        additionalNotes: 'Notas Adicionales', howDidYouHear: '\u00bfC\u00f3mo se enter\u00f3 de nosotros?',
        submitting: 'Enviando...', submitRequest: 'Enviar Solicitud',
        thankYouTitle: '\u00a1Gracias!', thankYouMsg: 'Su solicitud ha sido enviada exitosamente. Nuestro equipo revisar\u00e1 su informaci\u00f3n y se comunicar\u00e1 con usted dentro de 2-3 d\u00edas h\u00e1biles.',
        backToHome: 'Volver al Inicio',
        employed: 'Empleado', unemployed: 'Desempleado', selfEmployed: 'Independiente',
        student: 'Estudiante', retired: 'Jubilado',
        fullTime: 'Tiempo Completo', partTime: 'Medio Tiempo', weekends: 'Fines de Semana', flexible: 'Flexible',
        orgName: 'Nombre de Organizaci\u00f3n', orgType: 'Tipo de Organizaci\u00f3n', orgWebsite: 'Sitio Web',
        orgDescription: 'Descripci\u00f3n de la Organizaci\u00f3n', orgMission: 'Declaraci\u00f3n de Misi\u00f3n',
        contactName: 'Nombre de Contacto', contactTitle: 'T\u00edtulo de Contacto', contactEmail: 'Correo de Contacto', contactPhone: 'Tel\u00e9fono de Contacto',
        partnerInterest: 'Inter\u00e9s de Asociaci\u00f3n', additionalInfo: 'Informaci\u00f3n Adicional',
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('gci_language') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
